module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v(_vm._s(_vm.parseProviderName(_vm.providerName)))])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, _vm._l((_vm.contactLists), function(list) {
    return _c('div', {
      key: list.id
    }, [_c('el-card', {
      attrs: {
        "shadow": "hover"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('strong', [_c('el-link', {
      attrs: {
        "underline": false
      },
      on: {
        "click": function($event) {
          return _vm.$emit('onContactListClick', _vm.id, _vm.providerName, list)
        }
      }
    }, [_vm._v("\n              " + _vm._s(list.name) + "\n            ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('span', [_vm._v("Contact Count: " + _vm._s(list.contact_count))])])])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f5feff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/audience/ContactListItem.vue
// module id = 3241
// module chunks = 3